module.exports = __webpack_public_path__ + "img/japanese-“no-vacancy”-button.c99afd44.png";